<template>
    <div class="blocks mt-0">
        <v-layout row wrap>
            <v-flex xs6>
                <v-text-field
                        class="solo-input block-title"
                        v-model="blocks.name"
                        @input="$store.dispatch('updateBlockName',blocks)"
                        :disabled="blocks.slug === 'welcome-message' || blocks.slug === 'default-message' "
                ></v-text-field>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
                <v-btn fab dark small color="primary" @click="$store.dispatch('setCopiedBlock',blocks)">
                    <v-icon dark >file_copy</v-icon>
                </v-btn>
                <v-btn fab dark small
                       color="error"
                       @click="deleteBlockDialog = true"
                       :disabled="blocks.slug === 'welcome-message' || blocks.slug === 'default-message' "
                >
                    <v-icon dark>delete_outline</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <draggable v-model="blocks.payload" group="blocks" @start="drag=true" @end="drag=false" handle=".handle">
            <div
                class="block-item"
                v-for="(block, index) in blocks.payload"
                v-if="blocks.payload.length"
            >
                <component :is="getBlockName(block.block_id)" :data="block.data" :blocks-list="blocksList" :index="index"></component>
                <div class="block-actions">
                    <v-btn  @click="setDeleteBlockCard(index)" fab small color=""><v-icon small color="#666">delete_outline</v-icon></v-btn>
                    <v-btn  class="handle" fab small color=""><v-icon color="#666">height</v-icon></v-btn>
                </div>
            </div>
        </draggable>
        <v-dialog
                v-model="dialog"
                width="500"
        >
            <delete-dialog
                    title="this block"
                    @closeDialog="dialog = false"
                    @onDelete="deleteBlockCard(indexToDelete)"
            ></delete-dialog>
        </v-dialog>
        <v-dialog
                v-model="deleteBlockDialog"
                width="500"
        >
            <delete-dialog
                    :title="`block ${blocks.name}`"
                    @closeDialog="deleteBlockDialog = false"
                    @onDelete="deleteBlock"
            ></delete-dialog>
        </v-dialog>
        <add-block-buttons :blocks="blocks"></add-block-buttons>
    </div>
</template>

<script>
    import cardText from  './block-cards/card-text'
    import cardImageUrl from  './block-cards/card-image-url'
    import cardImage from  './block-cards/card-image'
    import cardGallery from  './block-cards/card-gallery'
    import cardVideo from  './block-cards/card-video'
    import cardGif from  './block-cards/card-gif'
    import cardSuggested from  './block-cards/card-suggested'
    import cardGoBlock from  './block-cards/card-go-block'
    import cardAudio from  './block-cards/card-audio'
    import cardTyping from  './block-cards/card-typing'
    import cardAttribute from  './block-cards/card-attribute'
    import cardUserInput from  './block-cards/card-user-input'
    import cardJson from  './block-cards/card-json'
    import cardRandom from  './block-cards/card-random'
    import cardBilling from  './block-cards/card-billing'
    import cardTravel from  './block-cards/card-travel'
    import cardFlight from  './block-cards/card-flight'
    import cardWeather from './block-cards/card-weather'
    import common from "../../../utils/common"
    import deleteDialog from '../../common/deleteDialog'
    import addBlockButtons from './add-block'
    import _ from "lodash"
    import draggable from 'vuedraggable'
    export default {
        name: "blocks",
        components: {
            cardText,
            cardImageUrl,
            cardImage,
            cardGallery,
            cardVideo,
            cardGif,
            cardSuggested,
            cardGoBlock,
            cardAudio,
            cardTyping,
            cardAttribute,
            cardUserInput,
            cardJson,
            cardRandom,
            cardBilling,
            cardTravel,
            cardFlight,
            deleteDialog,
            addBlockButtons,
            draggable,
            cardWeather
        },
        props: {
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                blocks: {},
                toDelete: {},
                dialog: false,
                deleteBlockDialog: false,
                indexToDelete: -1,
                blocksMapping:[
                    {id: 1, slug:'card-text'},
                    {id: 2, slug:'card-text'},
                    {id: 15, slug:'card-image-url'},
                    {id: 3, slug:'card-image'},
                    {id: 4, slug:'card-gallery'},
                    {id: 5, slug:'card-video'},
                    {id: 16, slug:'card-gif'},
                    {id: 17, slug:'card-suggested'},
                    {id: 18, slug:'card-go-block'},
                    {id: 6, slug:'card-audio'},
                    {id: 8, slug:'card-typing'},
                    {id: 10, slug:'card-attribute'},
                    {id: 11, slug:'card-user-input'},
                    {id: 12, slug:'card-json'},
                    {id: 14, slug:'card-random'},
                    {id: 19, slug:'card-billing'},
                    {id: 20, slug:'card-travel'},
                    {id: 22, slug:'card-flight'},
                    {id: 21, slug:'card-weather'}
                ]
            }
        },
        mounted() {
        },
        methods: {
            getBlock() {
                this.blocks = {}
                this.$store.dispatch('setLoader',true)
                this.$http_bot.get(`/blocks/${this.selectedBlock.id}`)
                    .then(response=>{
                        this.blocks = response.data
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            getBlockName(blockId) {
                const index = _.findIndex(this.blocksMapping, o=>{
                    return o.id === blockId
                })
                if ( index !== -1) {
                    return this.blocksMapping[index].slug
                }else {
                    return 'div'
                }
            },
            setDeleteBlockCard(index) {
                this.dialog = true
                this.indexToDelete = index
            },
            deleteBlockCard(index) {
                this.blocks.payload.splice(index, 1)
                this.dialog = false
            },
            updateBlock() {
                this.$store.dispatch('setSavingStatus', true)
                this.$http.put(`/blocks/${this.selectedBlock.id}`,this.blocks)
                    .then(response=>{
                        this.$store.dispatch('setSavingStatus', false)
                    })
                    .catch(error=>{
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            deleteBlock() {
                this.$store.dispatch('setDeletedBlock',this.blocks)
                this.deleteBlockDialog = false
            }
        },
        computed: {
            selectedBlock() {
                return this.$store.state.blocksBuild.selectedBlock
            }
        },
        watch: {
            selectedBlock (state) {
                if (state) {
                    this.getBlock()
                }
            },
            blocks: {
                handler(val ){
                    if (val.id) {
                        this.updateBlock()
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>